export function calculatePnL({
  side,
  openPrice,
  quantity,
  exitPrice,
}: {
  side?: string | null
  openPrice?: number | null
  quantity?: number | null
  exitPrice?: number | null
}): number | null {
  if (!side || openPrice == null || quantity == null || exitPrice == null) return null
  if (side !== 'BUY' && side !== 'SELL') return null
  return side === 'BUY' ? (exitPrice - openPrice) * quantity : (openPrice - exitPrice) * quantity
}
